export default __webpack_public_path__ + "static/media/BOB_0127.3d745c17.JPG";